import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Popover,
  Box,
  Typography,
  Button,
  Grid,
  Skeleton,
  useMediaQuery,
} from "@mui/material";
import restype from "../../assets/restype.png";
import {
  setSelectedEventOrStdResType,
  updateEventDates,
  updateEventOrStdTicketTypesData,
  updateReservationType,
  updateSelectedDate,
  updateStdDates,
} from "../../store/slice/Ticketing.slice";
import { useTheme } from "@emotion/react";
import ShowMoreLessText from "../horecaWidget/ShowMoreLessText";

const EventComponent = ({ Ref, isOpen, handleClose, isLoading }) => {
  const theme = useTheme();
  const matchesSm = useMediaQuery("sm");
  const [isImageValid, setIsImageValid] = useState(true);
  const [showMore, setShowMore] = useState(false);
  const { EventorStdTicketData, reservType } = useSelector(
    (store) => store?.Ticketing
  );
  const dispatch = useDispatch();
  // if(EventorStdTicketData?.length == 0 || !EventorStdTicketData?.success) return

  return (
    <Popover
      open={isOpen}
      anchorEl={Ref}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      PaperProps={{
        sx: {
          width: matchesSm ? "93%" : "100%",
          maxWidth: "1000px",
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          width: { xs: "100%", sm: "100%", md: "100%" }, // Full width for xs and sm, fixed width for md and above
          p: 3,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "1rem",
        }}
      >
        {EventorStdTicketData?.map((item, i) => (
          <Box
            key={item?.eventTicketId}
            // sx={{
            //   display: 'flex',
            //   flexDirection: { xs: 'column', sm: 'column', md: 'row' },
            //   gap: '0.5rem',
            //   backgroundColor: reservType?.name === item?.name ? '#0B5753' : '#EBEBEB',
            //   border: '1px solid #EBEBEB',
            //   p: 1,
            //   borderRadius: '8px',
            //   cursor: 'pointer',
            //   width: '100%',
            // }}
            sx={{
              display: "flex",
              width: "100%",
              flexDirection: { xs: "row" }, // Responsive flexDirection
              gap: "0.5rem",
              backgroundColor:
                reservType?.eventTicketId === item?.eventTicketId
                  ? theme?.resType?.itemBgActive
                  : theme?.resType?.itemBgColor,
              border: `1px solid ${theme?.resType?.borderColor}`,
              p: 2,
              borderRadius: "8px",
              cursor: "pointer",
              color:
                reservType?.eventTicketId === item?.eventTicketId
                  ? theme?.resType?.textColorActive
                  : theme?.resType?.itemTextColor,
              width: "100%", // Adjust width for small screens
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                transform: "scale(1.02)",
                boxShadow: "0px 6px 18px rgba(0,0,0,0.2)",
                backgroundColor: theme?.resType?.itemBgHover,
                color: theme?.resType?.textHover,
              },
            }}
            onClick={() => {
              dispatch(updateStdDates([]));
              dispatch(updateEventDates([]));
              dispatch(updateSelectedDate(""));
              dispatch(updateReservationType(item));
              dispatch(updateEventOrStdTicketTypesData([]));
              dispatch(setSelectedEventOrStdResType({}));
              handleClose();
            }}
          >
            <Grid container>
              {item?.imagePath && (
                <Grid item xs={12} sm={4} md={4}>
                  <Box
                    sx={{
                      width: "100%",
                      height: "100%",
                      maxHeight: "250px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "12px",
                      overflow: "hidden", // Ensures content stays within the rounded corners
                      "&:hover img": {
                        transform: "scale(1.05)", // Slight zoom effect on hover
                        transition: "transform 0.3s ease-in-out",
                      },
                    }}
                  >
                    <img
                      src={`${item?.imagePath}`}
                      alt="res-type-img"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover", // Ensures the image fills the space
                        borderRadius: "12px", // Apply border-radius to image
                        transition: "transform 0.3s ease-in-out",
                      }}
                      onLoad={() => {
                        setIsImageValid(true); // Confirm valid image
                      }}
                      onError={(error) => {
                        setIsImageValid(false); // Mark image as invalid
                      }}
                    />
                  </Box>
                </Grid>
              )}
              <Grid
                item
                xs={12}
                sm={item?.imagePath && isImageValid ? 8 : 12}
                md={item?.imagePath && isImageValid ? 8 : 12}
              >
                <Box sx={{ p: 1, width: "100%" }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "20px",
                        fontWeight: "600",
                      }}
                    >
                      {item?.eventTicketName}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                    >
                      {`${item?.address} ${item?.eventLocation && "|"} ${
                        item?.eventLocation
                      }`}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                    >
                      {item?.eventDateAndTime}
                    </Typography>
                    <ShowMoreLessText
                      text={item?.eventTicketInfo}
                      setIsShowMore={() => setShowMore(!showMore)}
                      isShowMore={showMore}
                      style={{
                        color:
                          reservType?.eventTicketId === item?.eventTicketId
                            ? theme?.resType?.textColorActive
                            : theme?.resType?.itemTextColor,
                        fontSize: "1.2rem",
                      }}
                    />
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                    >
                      {item?.eventInfo}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        ))}
      </Box>
    </Popover>
  );
};

export default EventComponent;
